export default __webpack_public_path__ + "static/media/2a7bba04-88cc-4753-b787-a16d88b7ad34.4c641179.webp";